import {action, makeAutoObservable, observable} from 'mobx';
import {localStore} from "./localStore";
import {makePersistable, stopPersisting} from "mobx-persist-store";
import {EmailTemplateDto} from "../model/EmailTemplates";
import {selectedCompanyStore} from "./SelectedCompany";


class AccountEmailState {
    readonly companyIdToLatestTemplate = observable(new Map<string, EmailTemplateDto | undefined>(), {deep: true});

    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: 'AccountEmailStateStore',
            properties: ['companyIdToLatestTemplate'],
            storage: localStore
        }).then(() => console.log("AccountEmailState hydrated"));
    }

    public stopPersisting = () => {
        stopPersisting(this)
    }

    public template() {
        return this.companyIdToLatestTemplate.get(selectedCompanyStore.companyId)
    }


    @action
    public setTemplate(template: EmailTemplateDto) {
        this.companyIdToLatestTemplate.set(selectedCompanyStore.companyId, template)
    }

    public getTo() {
        return this.companyIdToLatestTemplate.get(selectedCompanyStore.companyId)?.to
    }

    @action
    public setTo(to: string[]) {
        const templ = this.companyIdToLatestTemplate.get(selectedCompanyStore.companyId)
        if (templ) {
            this.companyIdToLatestTemplate.set(selectedCompanyStore.companyId, {...templ, to})
        } else {
            this.companyIdToLatestTemplate.set(selectedCompanyStore.companyId, {to})
        }
    }

    public getSubject() {
        return this.companyIdToLatestTemplate.get(selectedCompanyStore.companyId)?.subject
    }

    @action
    public setSubject(subject: string) {
        const templ = this.companyIdToLatestTemplate.get(selectedCompanyStore.companyId)
        if (templ) {
            this.companyIdToLatestTemplate.set(selectedCompanyStore.companyId, {...templ, subject})
        } else {
            this.companyIdToLatestTemplate.set(selectedCompanyStore.companyId, {subject})
        }
    }

    public getBody() {
        return this.companyIdToLatestTemplate.get(selectedCompanyStore.companyId)?.body
    }

    @action
    public setBody(body: string) {
        const templ = this.companyIdToLatestTemplate.get(selectedCompanyStore.companyId)
        if (templ) {
            this.companyIdToLatestTemplate.set(selectedCompanyStore.companyId, {...templ, body})
        } else {
            this.companyIdToLatestTemplate.set(selectedCompanyStore.companyId, {body})
        }
    }
}


export const accountEmailStateStore = new AccountEmailState();
